// extracted by mini-css-extract-plugin
export default {"main":"FinancialOverviewCard_main__TQxpH","title":"FinancialOverviewCard_title__kShKY","data":"FinancialOverviewCard_data__hPPGH"};